// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { ContactInfoPurposeType } from './contactInfoPurposeType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TrialcardPayorV4ModelsSharedEmailAddressModel {
    'emailAddressType'?: ContactInfoPurposeType;
    'address'?: string | null;
    'language'?: string | null;
    'emailAddressId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TrialcardPayorV4ModelsSharedEmailAddressModel>> = [
        {
            "name":     "emailAddressType",
            "baseName": "emailAddressType",
            "type":     "ContactInfoPurposeType"
        },
        {
            "name":     "address",
            "baseName": "address",
            "type":     "string"
        },
        {
            "name":     "language",
            "baseName": "language",
            "type":     "string"
        },
        {
            "name":     "emailAddressId",
            "baseName": "emailAddressId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return TrialcardPayorV4ModelsSharedEmailAddressModel.attributeTypeMap;
    }
}
